import { getHtmlFromTexElement, getHtmlElementFromEditText } from '@utils/textMultiStyling';
import {IElement, ITextAttributes } from 'routes/private/Editor/types';
import { updateRenderingTextSegments } from 'utils/textMultiStyling'

export const updateTextElementResolver = ( element: IElement, value: ITextAttributes ):IElement => {
    element.attributes = updateRenderingTextSegments(value);

    const editElement = getHtmlElementFromEditText();
    if (editElement) {
        const html = getHtmlFromTexElement(element.attributes);
        editElement!.innerHTML = html;
    }

    return element;
}